// core
import React from 'react';
import { Link } from 'react-router-dom'
import { Provider } from "react-redux"

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

class SurveyViewerPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fetching: false,
      error: '',
      status: 'default',

      survey: null,
      form: null
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { surveyId } = this.props.match.params;

    // get survey
    this.setState({
      fetching: true
    });

    // get survey
    API.call('GET', Settings.V2_API_URL + '/surveys/' + surveyId, {}, (response, error) => {
      if (error) {
        this.setState({
          fetching: false,

          error: error.message + ' while getting survey'
        });

        return false;
      }

      const survey = response.data.survey;
      const form = JSON.parse(survey.form);

      this.setState({
        fetching: false,

        survey,
        form
      });

      console.dir(this.state);
    });
  }

  handleSubmit(data) {
    this.setState({
      fetching: true
    });

    API.call('POST', Settings.V2_API_URL + '/surveys/' + this.state.survey.id + '/results', {
      form_data: JSON.stringify(data),
      respondent_id: 0,
    }, (response, error) => {
      this.setState({
        fetching: false
      });

      const err = error ? error.message : response.error;

      if (err) {
        this.setState({
          error: err
        });

        return false;
      }

      console.log('Saved!');

      this.setState({
        status: 'saved',
      });
    });
  }

  render() {
    var schema = this.state.form ? this.state.form.schema : {};
    var uiSchema = this.state.form ? this.state.form.uiSchema : {};

    return (
      this.state.error ? (
        <div className="alert alert-danger">
          <h2>Oh, mamma!</h2><p>{this.state.error}</p>
        </div>
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              {
                this.state.status == 'saved' ? (
                  <div className="alert alert-success">
                    <h2><i className="fa fa-thumbs-up" /> Grazie, sondaggio spedito!</h2>
                  </div>
                ) : ""
              }

              {
                this.state.survey ? (
                  <div>
                    <h1>{this.state.survey.title}</h1>
                    <p>{this.state.survey.title}</p>
                  </div>
                ) : ""
              }
            </div>
            <div className="col-md-6 text-right">
              {
                this.state.fetching || this.state.working ? (
                  <Spinner message="Attendere..." />
                ) : (
                  this.state.survey ? (
                    <div>
                      <Link className="btn btn-secondary mr-2" to={'/marketing/surveys/' + this.state.survey.id + '/edit/'}><i className="fa fa-pencil" /> Modifica</Link>
                      <Link className="btn btn-primary" to={'/marketing/surveys/' + this.state.survey.id + '/results/'}><i className="fa fa-chart-line" /> Visualizza risultati</Link>
                    </div>
                  ) : ''
                )
              }

            </div>
          </div>

          <div className="mt-4">
            {/* <FormBuilder.Viewer schema={schema} uiSchema={uiSchema} formData="" onSubmit={this.handleSubmit} /> */}
          </div>
        </div>
      )
    );
  }
}

export default SurveyViewerPage;


// WEBPACK FOOTER //
// ./src/pages/marketing/recipients/ListViewerPage.js